import styles from './styles.module.css'

interface ICleanlinessTrendProps {
  current: number | null
  previous: number | null
}

/** Signed change between two rolling scores; a dash when either is missing. */
function CleanlinessTrend({ current, previous }: ICleanlinessTrendProps) {
  if (current === null || previous === null) {
    return <span className={`${styles.trend} ${styles.muted}`}>—</span>
  }
  const delta = Math.round(current - previous)
  if (delta === 0) {
    return <span className={`${styles.trend} ${styles.muted}`}>0</span>
  }
  return (
    <span className={`${styles.trend} ${delta > 0 ? styles.up : styles.down}`}>
      {delta > 0 ? `+${delta}` : `−${Math.abs(delta)}`}
    </span>
  )
}

export default CleanlinessTrend
